import React from 'react';
import PropTypes from 'prop-types';

import CircularProgress from "@mui/material/CircularProgress";

import Badge from "components/Badge";

StatusBadge.propTypes = {
    process: PropTypes.string
};

function StatusBadge({process}) {
    switch (process) {
        case 'awaiting_import':
        case 'importing-products':
            return <Badge><CircularProgress size={10}/><span style={{marginLeft:'4px'}}>En cours</span></Badge>
        case 'error':
            return <Badge color={'error'}>À corriger</Badge>
        default:
            return <Badge color={'online'}>Terminé</Badge>
    }
}

export default StatusBadge;
